import { Fragment } from 'react'

import { Space } from '@tribeplatform/gql-client/types'

import { CollectionMenuSpaceItem } from './CollectionMenuSpaceItem.js'

export const CollectionMenuSpaces = ({ spaces }: { spaces: Space[] }) => (
  <Fragment>
    {spaces.map(space => (
      <CollectionMenuSpaceItem key={space.id} space={space} />
    ))}
  </Fragment>
)
